<template>
  <section class="login-page">
    <!-- <div class="logo-wrapper">
      <logo class="logo"></logo>
    </div> -->

    <div
      v-if="inviteKey && inviteValid === false"
      class="invite-warning"
    >
      <v-icon>warning</v-icon>
      <p>Запрошення, яким ви намагаєтесь скористатися не є дійсним. Після реестрації ви будете бачити лише публічні дописи.</p>
    </div>

    <div id="firebaseui-auth-container"></div>
    <loader v-if="applying" class="loader"></loader>

    <div class="fake-footer"></div>
  </section>
</template>

<script>
import firebase from 'firebase';
import * as firebaseui from 'firebaseui';
import moment from 'moment';
import ui from '@/firebase/ui';
import 'firebaseui/dist/firebaseui.css';

import Logo from '@/components/Logo';
import Loader from '@/components/Loader';

// import { getUser, createUser } from '@/firebase/repositories/users';
import { getUser, createUser, updateUser } from '@/firebase/repositories/users';
import { getInvite, isInviteActive } from '@/firebase/repositories/invites';
import { getAuth } from '@/firebase/repositories/auth';
import { USER_NOT_FOUND } from '@/firebase/errorTypes';
import { SET_USER, CLEAR_TARGET_ROUTE, SET_GLOBAL_NOTIFICATION } from '@/store/mutationTypes';

export default {
  name: 'Login',
  components: {
    Logo,
    Loader,
  },
  data() {
    return {
      applying: false,
      invite: null,
      // inviteValid: null,
    };
  },
  computed: {
    inviteKey() {
      return this.$route.params.invite;
    },
    inviteValid() {
      return this.invite && !this.invite.registeredUser;
    },
  },
  mounted() {
    if (!this.inviteKey) {
      this.initLogin();
    } else {
      getAuth()
        .then((auth) => {
          if (!auth) {
            this.loadInvite();
            this.initLogin();
          } else {
            this.tryToApplyInviteToUser(auth.uid, this.inviteKey);
          }
        });
    }
  },
  methods: {
    initLogin() {
      const uiConfig = {
        signInOptions: [
          firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          firebase.auth.FacebookAuthProvider.PROVIDER_ID,
          firebase.auth.EmailAuthProvider.PROVIDER_ID,
        ],
        credentialHelper: firebaseui.auth.CredentialHelper.NONE,
        signInFlow: 'popup',
        callbacks: { signInSuccess: this.onSignIn.bind(this) },
      };

      ui.reset();
      ui.start('#firebaseui-auth-container', uiConfig);
    },
    tryToApplyInviteToUser(uid, inviteKey) {
      this.applying = true;
      let inviteValid = false;

      return isInviteActive(inviteKey)
        .then((isValid) => {
          inviteValid = isValid;
          return getInvite(inviteKey);
        })
        .then((invite) => {
          let promise;

          if (inviteValid) {
            const updates = {
              invite: this.inviteKey,
            };

            Object.keys(invite.roles || {}).forEach((role) => { updates[`roles.${role}`] = true; });

            promise = updateUser(uid, updates)
              .then(() => {
                this.$store.commit(SET_GLOBAL_NOTIFICATION, {
                  status: 'success',
                  text: 'Запрошення успішно оброблене.',
                });
              });
          } else {
            this.$store.commit(SET_GLOBAL_NOTIFICATION, {
              status: 'error',
              text: 'Запрошення, яким ви намагаєтесь скористатися, недійсне.',
            });
          }

          return promise;
        })
        .then(() => (new Promise(resolve => setTimeout(resolve, 5000))))
        .then(() => { this.$router.replace({ name: 'home' }); });
    },
    // checkInvite() {
    //   isInviteActive(this.inviteKey)
    //     .then((status) => { this.inviteValid = status; });
    // },
    loadInvite() {
      getInvite(this.inviteKey)
        .then((invite) => { this.invite = invite; });
    },
    onSignIn(auth) {
      localStorage.setItem('wasLoggedId', true);

      getUser(auth.uid)
        .catch((reason) => {
          if (reason === USER_NOT_FOUND) {
            const { uid, email, displayName: name, photoURL: photoUrl } = auth;

            const invitePromise = this.inviteKey && this.inviteValid ?
              isInviteActive(this.inviteKey) : Promise.resolve();
            return invitePromise
              .then((inviteValid) => {
                const user = {
                  email,
                  name,
                  photoUrl,
                  created: moment().valueOf(),
                  roles: {
                    guest: true,
                  },
                };

                if (inviteValid) {
                  user.invite = this.inviteKey;
                  user.roles = { ...this.invite.roles };
                  // user.roles.member = true;
                }

                return createUser(user, uid)
                  .then((createdUser) => {
                    const messageSuffix = user.roles.member ? ' Завдяки запрошенню, яким ви скористалися ви можете бачити всі пости на сайті' : '';
                    this.$store.commit(SET_GLOBAL_NOTIFICATION, {
                      status: 'success',
                      text: `Ви успішно зареєстровані, вітаємо!${messageSuffix}`,
                    });
                    return createdUser;
                  });
              });
          }

          return Promise.reject(reason);
        })
        .then((user) => {
          this.$store.commit(SET_USER, user);

          const targetRoute = this.$store.state.targetRoute;
          if (targetRoute) {
            this.$store.commit(CLEAR_TARGET_ROUTE);
          }
          this.$router.replace(targetRoute || { name: 'home' });
        });

      return false;
    },
  },
};
</script>

<style scoped>

.login-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  /*background: #181e00;*/
}

.logo-wrapper {
  width: 300px;
  padding-top: 100px;
  margin: 0 auto;
}

.logo {
  stroke: #eee !important;
}

.invite-warning {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 400px;
  padding: 0 5px 0 10px;
  color: #b9b9b9;
  border: dashed 2px #b9b9b9;
  font-size: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.invite-warning .icon {
  color: #b9b9b9;
  width: 80px;
  display: block;
}

@media (max-width: 1300px) {
  .invite-warning {
    position: static;
    margin: 10px auto;
  }
}


.loader {
  margin: 0 auto;
}

</style>

<style>

.global-page-container.login {
  background:  #181e00;
}

#firebaseui-auth-container .firebaseui-idp-button, #firebaseui-auth-container .firebaseui-idp-button:hover {
  background-color: #fff !important;
}

#firebaseui-auth-container .firebaseui-idp-text {
  color: #757575;
}

#firebaseui-auth-container .firebaseui-idp-button:hover .firebaseui-idp-text {
  color: #222;
}

#firebaseui-auth-container .firebaseui-idp-facebook .firebaseui-idp-icon-wrapper img,
#firebaseui-auth-container .firebaseui-idp-password .firebaseui-idp-icon-wrapper img {
  display: none;
}

#firebaseui-auth-container .firebaseui-idp-facebook .firebaseui-idp-icon-wrapper,
#firebaseui-auth-container .firebaseui-idp-password .firebaseui-idp-icon-wrapper {
  width: 18px;
  height: 18px;
  border-radius: 2px;
}

#firebaseui-auth-container .firebaseui-idp-facebook .firebaseui-idp-icon-wrapper {
  background: url('../assets/facebook.png');
}

#firebaseui-auth-container .firebaseui-idp-password .firebaseui-idp-icon-wrapper {
  background: url('../assets/mail.png') no-repeat center center;
}

</style>



// WEBPACK FOOTER //
// src/containers/LoginPage.vue